{
  "salon-card": {
    "text": {
      "and-x-more": "et {{nr}} plus",
      "points": "points"
    }
  }
}
